import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Forbidden extends Vue {
	get erroMsg() {
		if (!this.$route.query.cod) {
			return 'Erro sem código, entre em contato com nosso setor de T.I.'
		}
		if (this.$route.query.cod === 'FALTANDO_PERMISSOES') {
			return 'Você não tem as permissões necessárias para executar essa ação'
		}

		if (this.$route.query.cod === 'NAO_COLABORADOR') {
			return 'Apenas colaboradores têm acesso a essa página'
		}

		if (this.$route.query.cod === 'COLABORADOR_NAO_VERIFICADO') {
			return 'Você é um colaborador porém seu email não está verificado'
		}

		return 'Erro desconhecido, entre em contato com nosso setor de T.I.'
	}
}
